import { type FieldContentsData } from 'javascripts/shared-types';
import Field from '../../Field';

export class PortalVisibility extends Field {
  static attributesForModel() {
    return ['visibility'];
  }

  get title() {
    return 'Portal visibility';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Visible to all' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record?.visibility) {
      let text = '';
      switch (record.visibility) {
        case 'VISIBILITY_AHA':
          text = 'Not visible';
          break;
        case 'VISIBILITY_CREATOR':
          text = 'Visible to creator';
          break;
        case 'VISIBILITY_EMPLOYEE':
          text = 'Visible to our employees';
          break;
        case 'VISIBILITY_EMPLOYEE_OR_CREATOR':
          text = 'Visible to creator and our employees';
          break;
        case 'VISIBILITY_EMPLOYEE_OR_CREATOR_ORG':
          text = 'Visible to creator, their organization, and our employees';
          break;
        case 'VISIBILITY_PUBLIC':
          text = 'Visible to all';
          break;
      }
      return {
        text: text,
      };
    }

    return {};
  }
}
